import { UseRecommendationProductInterface } from "./useRecommendationProductInterface";
import api from "~/config/extensionsApi";
import { ref } from "@nuxtjs/composition-api";
import { postApiAxios } from "~/helpers";
import { useConfigStore } from "~/stores/extensionApi";

export function useRecommendationProduct(): UseRecommendationProductInterface {
  const loading = ref<boolean>(false);
  const recommendedProducts = ref<any[]>([]);

  const getProductRecommendation = async (userCode: string, internalRefCode: string) => {
    loading.value = true;
    try {
      const response = await postApiAxios(api.sales.product_recommendation, {
        user_code: userCode,
        internal_ref_code: internalRefCode,
      });

      recommendedProducts.value = response?.result || [];
      return response.data;
    } catch (error) {
      console.error("Error fetching product recommendations:", error);
      return null;
    } finally {
      loading.value = false;
    }
  };

  const getRecommentProductCart = async (user_id: string, cart_items: string[]) => {
    loading.value = true;
    try {
      let recommendedProductsCart = [];
      const storeConfig = useConfigStore();
      const suggestionStatus = storeConfig.getStatusSuggestion;
      if (!suggestionStatus) {
        return recommendedProductsCart;
      }
      
      const response = await postApiAxios(api.sales.recommend_product_cart, {
        user_id: user_id,
        cart_items: cart_items,
      });

      if (response && response.code == 200) {
        recommendedProductsCart = response?.result?.suggestions ? response?.result?.suggestions : [];
      }
      return recommendedProductsCart;
    } catch (error) {
      console.error("Error fetching product recommendations cart:", error);
      return null;
    } finally {
      loading.value = false;
    }
  };

  return {
    loading,
    recommendedProducts,
    getProductRecommendation,
    getRecommentProductCart,
  };
}
